import React, { FC } from 'react';
import classes from './styles/publicJobDetailLayout.module.scss';
import { PaddingBox } from '../../../../../../../ReactSharedScripts/components/PaddingBox';

type PublicJobDetailLayoutComponents = {
	Main: FC<React.PropsWithChildren>;
	Aside: FC<React.PropsWithChildren>;
	TopSection: FC<React.PropsWithChildren>;
	BottomSection: FC<React.PropsWithChildren>;
};

export const PublicJobDetailLayout: FC<React.PropsWithChildren> & PublicJobDetailLayoutComponents = ({ children }) => {
	return (
		<PaddingBox
			small
			className={classes.publicJobDetailLayout}
		>
			<div className={classes.detailContainer}>{children}</div>
		</PaddingBox>
	);
};

const PublicJobDetailLayoutMain: FC<React.PropsWithChildren> = ({ children }) => {
	return <main className={classes.main}>{children}</main>;
};

const PublicJobDetailLayoutAside: FC<React.PropsWithChildren> = ({ children }) => {
	return <aside className={classes.aside}>{children}</aside>;
};

const PublicJobDetailLayoutTopSection: FC<React.PropsWithChildren> = ({ children }) => {
	return <div className={classes.topSection}>{children}</div>;
};

const PublicJobDetailLayoutBottomSection: FC<React.PropsWithChildren> = ({ children }) => {
	return <aside className={classes.bottomSection}>{children}</aside>;
};

PublicJobDetailLayout.Main = PublicJobDetailLayoutMain;
PublicJobDetailLayout.Aside = PublicJobDetailLayoutAside;
PublicJobDetailLayout.TopSection = PublicJobDetailLayoutTopSection;
PublicJobDetailLayout.BottomSection = PublicJobDetailLayoutBottomSection;
